import { cols } from './cols';

export class datarows {
  keyvalue: string;
  action: string;
  status: boolean;
  cols: cols[];
  count: any;
}
